import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, "data-testid": testId }) => {
  const isPaid = status === "paid";
  return (
    <Badge
      variant="outline"
      data-testid={testId}
      className={cn(
        "rounded-sm uppercase tracking-wider font-semibold text-[10px] px-2 py-0.5 border",
        isPaid
          ? "bg-emerald-50 text-emerald-800 border-emerald-200"
          : "bg-rose-50 text-rose-800 border-rose-200"
      )}
    >
      {isPaid ? "Paid" : "Unpaid"}
    </Badge>
  );
};
